import ApiMiddleware from 'CORE/api-middleware'
import currentUserStore, { setCurrentUserApiMiddleware } from 'CORE/stores/current-user'
import usersStore, { setUsersApiMiddleware } from 'CORE/stores/users'
import projectsStore, { setProjectsApiMiddleware } from 'CORE/stores/projects'
import resourcesStore, { setResourcesApiMiddleware } from 'CORE/stores/resources'
import dataTypesStore, { setDataTypeApiMiddleware } from 'CORE/stores/data-type'
import propertyTypesStore, { setPropertyTypeApiMiddleware } from 'CORE/stores/property-type'
import projectTypesStore, { setProjectTypeApiMiddleware } from 'CORE/stores/project-type'
import resourceTypesStore, { setResourceTypeApiMiddleware } from 'CORE/stores/resource-type'
import tasksStore, { setTasksApiMiddleware } from 'CORE/stores/tasks'
import taskTypesStore, { setTaskTypeApiMiddleware } from 'CORE/stores/task-type'
import commentsStore, { setCommentApiMiddleware } from 'CORE/stores/comment'
import attachmentsStore, { setAttachmentApiMiddleware } from 'CORE/stores/attachment'
import companyTemplatesStore, { setCompanyTemplateApiMiddleware } from 'CORE/stores/company-template'
import aclStore, { setAclApiMiddleware } from 'CORE/stores/acl'
import taskStateStore from 'CORE/stores/task-state'
import locksStore from 'CORE/stores/locks'

export const defaultApiMiddleware = new ApiMiddleware('/api/v1')

setCurrentUserApiMiddleware(defaultApiMiddleware)
setUsersApiMiddleware(defaultApiMiddleware)
setProjectsApiMiddleware(defaultApiMiddleware)
setResourcesApiMiddleware(defaultApiMiddleware)
setDataTypeApiMiddleware(defaultApiMiddleware)
setPropertyTypeApiMiddleware(defaultApiMiddleware)
setProjectTypeApiMiddleware(defaultApiMiddleware)
setResourceTypeApiMiddleware(defaultApiMiddleware)
setTaskTypeApiMiddleware(defaultApiMiddleware)
setTasksApiMiddleware(defaultApiMiddleware)
setCommentApiMiddleware(defaultApiMiddleware)
setAttachmentApiMiddleware(defaultApiMiddleware)
setAclApiMiddleware(defaultApiMiddleware)
setCompanyTemplateApiMiddleware(defaultApiMiddleware)

const storesMap = new Map()

storesMap.set('currentUser', currentUserStore())
storesMap.set('projects', projectsStore())
storesMap.set('resources', resourcesStore())
storesMap.set('users', usersStore())
storesMap.set('dataTypes', dataTypesStore())
storesMap.set('propertyTypes', propertyTypesStore())
storesMap.set('projectTypes', projectTypesStore())
storesMap.set('resourceTypes', resourceTypesStore())
storesMap.set('tasks', tasksStore())
storesMap.set('taskTypes', taskTypesStore())
storesMap.set('comments', commentsStore())
storesMap.set('attachments', attachmentsStore())
storesMap.set('taskState', taskStateStore())
storesMap.set('locksStore', locksStore())
storesMap.set('aclStore', aclStore())
storesMap.set('companyTemplatesStore', companyTemplatesStore())

export default storesMap
